<template >
<div class="back1"><img src="../assets/fondos/Ellipse1.png" alt=""></div>
<div class="back2"><img src="../assets/fondos/Ellipse2.png" alt=""></div>
<div class="back3"><img src="../assets/fondos/Ellipse3.png" alt=""></div>
<div class="back4"><img src="../assets/fondos/Ellipse4.png" alt=""></div>
<div class="back5"><img src="../assets/fondos/Ellipse5.png" alt=""></div>
<div class="back6"><img src="../assets/fondos/Ellipse6.png" alt=""></div>
<div class="back7"><img src="../assets/fondos/Ellipse7.png" alt=""></div>
<div class="back8"><img src="../assets/fondos/Ellipse8.png" alt=""></div>
<div class="back13"><img src="../assets/fondos/Ellipse13.png" alt=""></div>
<div class="back14"><img src="../assets/fondos/Ellipse14.png" alt=""></div>

  <el-row id="home">  
       <el-menu :default-active="activeIndex" active-text-color="#fff"
      background-color="transparent" 
      mode="horizontal" @select="handleSelect" class=" nave navbar"  >
          <el-menu-item class="nohov"  v-on:click="scrollPageTo('home')" ><router-link to=""> Alfa-Manosidosis</router-link></el-menu-item>
          <el-menu-item class="nohov" v-on:click="scrollPageTo('home')" ><router-link to="">¿Qué es?</router-link></el-menu-item>
          <el-menu-item class="nohov" v-on:click="scrollPageTo('sintomas')"><router-link to="">Síntomas</router-link></el-menu-item>
          <el-menu-item class="nohov" v-on:click="scrollPageTo('form')"><router-link to="">¿Conoces a alguien que lo padece?</router-link></el-menu-item>
          <el-menu-item class="soy" @click="modale">
            <router-link to="" v-if="!showMaterial">Soy profesional de la salud</router-link>
            <router-link to="" v-else> Soy paciente</router-link>
            </el-menu-item>  
      </el-menu>
  <el-col :span="24">
    <el-menu 
      default-active="1"
      class="demo"
      hide-timeout=1
      >
      <el-submenu disabled="true" index="1" >
          <el-menu-item index="1-1" v-on:click="scrollPageTo('home')" ><router-link to=""> Alfamanosidosis</router-link></el-menu-item>
          <el-menu-item index="1-2" v-on:click="scrollPageTo('home')" ><router-link to="">¿Qué es?</router-link></el-menu-item>
          <el-menu-item index="1-3" v-on:click="scrollPageTo('sintomas')"  ><router-link to="">Síntomas</router-link></el-menu-item>
          <el-menu-item index="1-4"  v-on:click="scrollPageTo('form')"><router-link to="">¿Conoces a alguien que lo padece?</router-link></el-menu-item>
          <el-menu-item index="1-5" @click="modal">
          <router-link to="" v-if="!showMaterial">Soy profesional de la salud</router-link>
          <router-link to="" v-else> Soy paciente</router-link>
          </el-menu-item>  
          
        </el-submenu>
    </el-menu>
      <i open class="el-icon-s-unfold "></i> 
        
  </el-col>
      </el-row>
      <el-row class="mtop" id="que">
          <el-col :lg="12" :md="10" :sm="22" :xs="22" class="md6 que el-col-md-offset-2 el-col-sm-offset-1 el-col-xs-offset-1">
          <h1 class="pl10 my0">¿Qué es la <br>Alfa-Manosidosis?</h1>
          <p class="pl10 my5 la hidden-xs-only">La Alfa-Manosidosis es una enfermedad ultrarrara del grupo de <br>
         las enfermedades lisosomales causada en el gen MAN2B1 <br> 
         provocando el déficit de la enzima alfa-manosidasa
          lisosomal.</p>
          <p class="hidden-md-and-up">La Alfa-Manosidosis es una enfermedad ultrarrara del grupo de 
         las enfermedades lisosomales causada en el gen MAN2B1 
         provocando el déficit de la enzima alfa-manosidasa
          lisosomal.</p>
          </el-col>
      <el-col  :lg="8" :md="3" :sm="24" class="md6 land">
        <img src="../assets/doctora.png" alt="">
      </el-col>
        </el-row>
        
      <el-row>
        <el-col class="box" @click="scrollPageTo('sintomas')">
          <img src="../assets/vermas.png" alt="">
          <p class="verMas"> Más </p>
        </el-col>
        </el-row>
        
    <Sintomas @slide="slide" ref="sintomas"/>
    <Material v-if="showMaterial" :elemental="elemental" />
    <Form /> 
    <Modal v-if="showOverlay" />
    </template>

<script>
import Sintomas from '@/components/home/sintomas.vue'
import Form from '@/components/home/form.vue'
import Material from '@/components/home/material.vue'
import Modal from '@/components/home/modal.vue'


import {ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'Home',
  components: {
    Sintomas,Form, Material, Modal
  },
setup(){ 
  const store = useStore()
  
    const getlElementos = store.dispatch("getElementos")
    const elementos = computed(() => store.state.elementos)
    const elemental = ref(elementos)
    const mater =() => store.commit('mater')
    const modal = () => store.commit('modal')
    const sintomas = ref(null)  
    const checkSintomas = computed(() => store.state.checkSintomas)
    const showMaterial = computed(() => store.state.showMaterial)   
    const showOverlay = computed(() => store.state.showOverlay)        
    const scrollPosition = ref(null)
    const x = ref(null)
    const getWidth = () =>{
      x.value = screen.width
    } 
    const updateScroll = () => {
        scrollPosition.value = window.scrollY;
        if(showMaterial.value){
          console.log('ftw')
          if(scrollPosition.value < 2850){
          if(screen.width < 768 ){
            document.querySelector(".back1").style.top = 450 + scrollPosition.value * 1.2+"px"
            document.querySelector(".back2").style.top = 50 + scrollPosition.value * 1+"px"
            document.querySelector(".back3").style.top = 280 + scrollPosition.value * .6+"px"
            document.querySelector(".back4").style.top = 520 + scrollPosition.value * .8+"px"
            document.querySelector(".back5").style.top = 600+ scrollPosition.value * 1.5+"px"
            document.querySelector(".back6").style.top = 56 + scrollPosition.value * 1+"px"
            document.querySelector(".back7").style.top = 620 + scrollPosition.value * .2+"px"
            document.querySelector(".back8").style.top = 920 + scrollPosition.value * .4+"px"
            document.querySelector(".back13").style.top =1060 + scrollPosition.value *1.2+"px"
            document.querySelector(".back14").style.top = 1050 + scrollPosition.value *.5+"px"

          }else{
        document.querySelector(".back1").style.top = scrollPosition.value * 1.2+"px"
        document.querySelector(".back2").style.top = scrollPosition.value * 1+"px"
        document.querySelector(".back3").style.top = scrollPosition.value * .3+"px"
        document.querySelector(".back4").style.top = scrollPosition.value * .8+"px"
        document.querySelector(".back5").style.top = 350 + scrollPosition.value * 1.1+"px"
        document.querySelector(".back6").style.top = scrollPosition.value * 1+"px"
        document.querySelector(".back7").style.top = scrollPosition.value * .4+"px" 
        document.querySelector(".back13").style.top =960 + scrollPosition.value *.9+"px"
        document.querySelector(".back14").style.top = 1050 + scrollPosition.value *.75+"px"
        
          }
        }
        }else{
          console.log('wtf')
          if(scrollPosition.value < 2400){
          if(screen.width < 768 ){
            document.querySelector(".back1").style.top = 450 + scrollPosition.value * 1.2+"px"
            document.querySelector(".back2").style.top = 50 + scrollPosition.value * 1+"px"
            document.querySelector(".back3").style.top = 280 + scrollPosition.value * .6+"px"
            document.querySelector(".back4").style.top = 520 + scrollPosition.value * .8+"px"
            document.querySelector(".back5").style.top = 600+ scrollPosition.value * 1.1+"px"
            document.querySelector(".back6").style.top = 56 + scrollPosition.value * 1+"px"
            document.querySelector(".back7").style.top = 620 + scrollPosition.value * .2+"px"
            document.querySelector(".back8").style.top = 920 + scrollPosition.value * .4+"px"
            document.querySelector(".back13").style.top = 1050 + scrollPosition.value *1+"px"
            
          }else{
        document.querySelector(".back1").style.top = scrollPosition.value * 1.2+"px"
        document.querySelector(".back2").style.top = scrollPosition.value * 1+"px"
        document.querySelector(".back3").style.top = scrollPosition.value * 1.2+"px"
        document.querySelector(".back4").style.top = scrollPosition.value * .8+"px"
        document.querySelector(".back5").style.top = 350 + scrollPosition.value * 1.1+"px"
        document.querySelector(".back6").style.top = scrollPosition.value * 1+"px"
        document.querySelector(".back7").style.top = scrollPosition.value * .4+"px"
        document.querySelector(".back8").style.top = 920 + scrollPosition.value * .4+"px"
            document.querySelector(".back13").style.top = 650 + scrollPosition.value *.85+"px"
            
          }
        }
        }


      
        }
    onMounted(() => {window.addEventListener("scroll", updateScroll)
    })
    const close = ref(false)
        console.log(showMaterial.value)

    const modale = () =>{
      if(showMaterial.value === true){
        window.scrollTo({top:0, behavior:'smooth'}) 
        mater()
        console.log(showMaterial.value  )
        
      }else{
        modal()
        console.log(showMaterial.value  )

        }
    }  
   
   const scrollPageTo = (navEl) => {
      document.querySelector(".el-menu--inline").style.display = "none"
      console.log(`#${navEl}`);
      let element = document.querySelector(`#${navEl}`)
      console.log(checkSintomas.value+ "aber")
      console.log(element);
      
      if(navEl == 'home'){
        window.scrollTo({top:0, behavior:'smooth'}) 
        document.querySelector(".el-submenu .el-menu").style.display="none"

      }
      if(navEl =='sintomas'){
        if((screen.width < 500)){
          window.scrollTo({top:730, behavior:'smooth'})  
        console.log('chico')
        
      document.querySelector(".el-submenu .el-menu").style.display="none"
        }
        if((screen.width > 500) && (screen.width < 769) ) {
          window.scrollTo({top:960, behavior:'smooth'})  
          console.log('chicoloa')
        
        }
        if((screen.width > 769) && (screen.width < 1450)){
          window.scrollTo({top:700, behavior:'smooth'}) 
          console.log('chicoloa1')
        }
        if(screen.width > 1465){
          window.scrollTo({top:830, behavior:'smooth'}) 
          
        } 
      }
      if( (navEl =='form') && (showMaterial.value == false) ){
        if( screen.width < 500){
          window.scrollTo({
            top:2600, behavior:'smooth'
          })
          
      document.querySelector(".el-submenu .el-menu").style.display="none"  
        }
        if((screen.width > 500) && (screen.width < 769)){
          window.scrollTo({
            top:2600, behavior:'smooth'
          })
          
      document.querySelector(".el-submenu .el-menu").style="none"
        } 
        if((screen.width > 769) && (screen.width < 1450)){
          window.scrollTo(0,2500)
          setTimeout(() =>{
            window.scrollBy({top:435, behavior:'smooth'})
          },100)
        }
        if(screen.width > 1450){
          window.scrollTo(0,2500)
          setTimeout(() =>{
            window.scrollBy({top:735, behavior:'smooth'})
          },100)
        }
      } 
      if((navEl =='form') && (showMaterial.value == true)){
          if(screen.width < 500){
            window.scrollTo({
            top:4270, behavior:'smooth'
          })
            
      document.querySelector(".el-submenu .el-menu").style.display="none"
          }
          if((screen.width >500) && (screen.width < 769)){
          window.scrollTo({
            top:3500, behavior:'smooth'
          })
        }
        if(screen.width >769){
               window.scrollTo(0,2500)
           setTimeout(() =>{
            
            window.scrollBy({top:1325, behavior:'smooth'})
            console.log(checkSintomas.value+" del click")
            
            },100)
          }
      }

   }
   let index = ref(0);
   const slide = () => index.value++

  return { index, slide, scroll, showMaterial,showOverlay,
   mater, modal, scrollPageTo,getlElementos,elemental, 
   checkSintomas, sintomas, x, getWidth, close, modale
    }
}
}

</script>
<style lang="scss" scoped>
  
  .back1{
    position: absolute;
   right: 0;
   top: 626px;
  }
  .back1 img {
    
    height: 440px;
    width: 440px;
  }
  .back2{
    position: absolute;
    right: 0;
    top: -80px;
  }
  .back2 img{
    width: 866px;
    height: 866px;
  }
  .back3{
    position: absolute;
    left: 557px;
    top: 242px;
  }
  .back3 img{
    width: 740px;
    height: 740px;
  }
  .back4{
    left: -100px;
    top: 572px;
    position: absolute;
  }
  .back4 img{
    width: 509px;
    height: 509px;
  }
  .back5{
    position: absolute;
    right: 0;
    top: 350px;
  }
  .back5 img{
    width: 416px;
    height: 416px;
  }
  .back6{
    position: absolute;
    left: -105px;
    top: -95px;
  }
  .back6 img{
    width: 840px;
    height: 840px;
  }
  .back7{
    position: absolute;
    left: -35px;
    top: 828px;
  }
  .back7 img{
    width: 868px;
  }
  .back8{
    position: absolute;
    right: 0;
    top: 1710px;
  }
  .back8 img{
    width: 1080px;
  }
  .back13{
    position: absolute;
    left: 384px;
    top: 2640px;
  }
  .back13 img{
    width: 750px;
    
  }
  .back14{
    position: absolute;
    right: 0;
    top: 2587px;
  }
  .back14 img{
    width: 698px;
  }
  .mtop{
    margin-top: 210px;
  }
  .land{
    margin-top: 20px;
    padding-right:10%;
  }
  .land img{
    height: 419px
  }
  h1{
    color:#000D5A;
    font-size: 54px;
    font-family: "Yusei-Magic";
    margin-bottom: 35px !important ;
  }
  .que{
    margin-top: 80px;
    text-align: left;

  }
  .box{
    margin-top: 190px;
    
  }
  .box img{
    cursor: pointer;
  }
  .box p{
  position: absolute;
  padding-bottom: 140px;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  font-family: "Yusei-Magic";
  }
  .la{
    font-family: "Avenir";
    font-size: 18px;
    line-height: 30px;
    text-align: left;
  }
  @media (min-width:1700px) {
      .back1 img{
        height: 550px;
        width: 550px;
      }
      .back2 img {
        width: 980px;
        height: 980px;
      }
      .back8 img{
        width: 1180px;
      }
      .back14 img{
        width: 850px;
      }
      .el-menu--horizontal>.el-menu-item{
        height: 100px;
      }
  }
  @media (max-height:900px) { 
  .mtop{
    margin-top: 120px;
  }
  
  .box{
    margin-top: 70px;
  }
  }
  @media(max-height:800px){
    .mtop{
      margin-top:30px;
    }
    .box{
      margin-top:0px
    }
    .land img{
      height:370px;
      margin-top:30px
    }
  }
  @media (max-width:1300px) {
      .back3 img{
        width: 450px;
        height: 450px;
      }
  }
  @media (max-width:1024px) {
    
    .land{
      margin-top: 90px;
    }
    .land img{
      height: 400px;
    }
    .mtop{
      margin-top: 50px;
    }
    h1{
      font-size: 44px;
    }
    .back3{
      left: unset;
      right: 0;
    }
    .back3 img{
      height: 340px;
      width: 340px;
    }
    .back13{
            left: 0;
      right: 0;
    }
    .back13 img{

      height: 700px;
      width: 700px;
    }
    .really{
      padding-left: 25%;
      padding-left: 25%;
    }
  }
  @media (max-width:768px) {
    .demo{
      font-family: "Yusei-Magic";
    }
      .mtop{
        margin-top: 00px;
      }
     
   .que{
     font-size: 24px;
   }
      .que, .la{

      text-align: center  !important;
      }
      .land{
        padding-right: 0%;
        margin-top: 0px;
      }
    .back1 img{
      height: 361px;
      width: auto;
    }
    .back2{
      top:50px;
    }
    .back2 img{
      width: 266px;
      height: auto;
    }
    .back3{
      left: 20%;
      top: 100px;
    }
    .back3 img{
      width: 280px;
      height: auto;
    }
    .back4{
      left: 0vw;
    }
    .back4 img{
      width:150px;
      height: auto;
    }
    .back5 img{
      width: 150px;
      height: auto;
    }
    .back6{
      left: 0vw;
    }
    .back6 img{
      width: 180px;
      height: auto;
    }
    .back7{
      left: 0vw;
    }
    .back7 img{
      width:200px;
      height: auto;
    }
    .back8 img{
      width: 180px;
      height: auto;
    }
    .back13{
      top: 2400px;
      left: 2vw;
    }
    .back13 img{
      width: 320px;
      height: auto;
    }
    .back14 img{
      width: 200px;
      height: auto;
    }
      
     }
  @media (max-width: 500px) {

    a{
      font-size: 18px;
    }
      h1{
        text-align: start !important;
        padding-left: 15px !important;
        font-size: 30px !important;
      }
      .la{
        text-align: center;
      }
      .land img{
        width: 80%;
        height: auto;
      }
      .que{
        font-size: 15px;
        margin-top: 45px;
      }
      .box{
        margin-top: 5px;
        margin-bottom: 10px;
      }
      .demo .el-submenu__title{
        cursor: auto
        ;
      }
  }
  @media (max-width:900px) and (max-height:350px) {
    
  }
</style>